import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "max-w-2xl lg:max-w-7xl mx-auto space-y-12" }
const _hoisted_2 = {
  key: 0,
  class: "max-w-2xl mx-auto flex flex-col gap-y-2"
}
const _hoisted_3 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-4 mx-auto max-w-7xl text-center" }
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = { class: "flex flex-col gap-2" }
const _hoisted_6 = { class: "flex justify-center grow" }
const _hoisted_7 = { class: "w-full h-full rounded-lg aspect-[3/2] lg:aspect-auto overflow-hidden" }
const _hoisted_8 = { class: "flex flex-col gap-4" }
const _hoisted_9 = { class: "flex flex-col gap-2" }
const _hoisted_10 = { class: "grow overflow-hidden" }
const _hoisted_11 = { class: "w-full h-full rounded-lg aspect-[3/2] lg:aspect-auto overflow-hidden" }
const _hoisted_12 = { class: "flex flex-col gap-2" }
const _hoisted_13 = { class: "grow overflow-hidden" }
const _hoisted_14 = { class: "w-full h-full rounded-lg aspect-[3/2] lg:aspect-auto overflow-hidden" }
const _hoisted_15 = { class: "flex flex-col h-full overflow-hidden" }
const _hoisted_16 = { class: "flex flex-col gap-2" }
const _hoisted_17 = { class: "flex justify-center grow" }
const _hoisted_18 = { class: "w-full h-full rounded-lg aspect-[3/2] lg:aspect-auto overflow-hidden" }

import { CssVarColors } from "@/shared/themes/CssVarColors.interface";
import type { PageBlock } from "@/views/blocks/PageBlock.interface";
import EditableElement from "@/views/page/EditableElement.vue";
import { computed } from "vue";
import type { ThreeColumnProps } from "./bento.interfaces";
import TagComponent from "./three-column/tag/TagComponent.vue";
import TitleComponent from "./three-column/title/TitleComponent.vue";
import BlockTitle from "./three-column/block/title/BlockTitle.vue";
import BlockDescription from "./three-column/block/description/BlockDescription.vue";
import Media from "../shared/section/media/media/Media.vue";
import Section from "../shared/section/layout/section/Section.vue";
import FullSpacing from "../shared/section/layout/spacing/FullSpacing.vue";
import type { ScrollAnimationType } from "@/apps/page/page-project.interface";


export default /*@__PURE__*/_defineComponent({
  __name: 'ThreeColumn',
  props: {
    block: {},
    pageColors: {},
    scrollAnimationType: {}
  },
  setup(__props: any) {

const props = __props;

const dataValues = computed(() => props.block.dataValues);
const styleValues = computed(() => props.block.styleValues);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Section, {
    id: _ctx.block.webId,
    backgroundColor: styleValues.value.background,
    scrollAnimationType: _ctx.scrollAnimationType
  }, {
    default: _withCtx(() => [
      _createVNode(FullSpacing, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (!dataValues.value.tag.isHidden || !dataValues.value.title.isHidden)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (!dataValues.value.tag.isHidden)
                    ? (_openBlock(), _createBlock(EditableElement, {
                        key: 0,
                        blockId: _ctx.block.id,
                        fieldName: "tag"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TagComponent, {
                            text: dataValues.value.tag.data.text,
                            textColor: styleValues.value.brand
                          }, null, 8, ["text", "textColor"])
                        ]),
                        _: 1
                      }, 8, ["blockId"]))
                    : _createCommentVNode("", true),
                  (!dataValues.value.title.isHidden)
                    ? (_openBlock(), _createBlock(EditableElement, {
                        key: 1,
                        blockId: _ctx.block.id,
                        fieldName: "title"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TitleComponent, {
                            tag: dataValues.value.title.data.tag,
                            text: dataValues.value.title.data.text,
                            textColor: styleValues.value.text
                          }, null, 8, ["tag", "text", "textColor"])
                        ]),
                        _: 1
                      }, 8, ["blockId"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", {
                  class: "rounded-lg border p-8 h-full flex flex-col gap-4",
                  style: _normalizeStyle({
                                borderColor: styleValues.value.border,
                                backgroundColor: styleValues.value.cardBackground,
                            })
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    (!dataValues.value.leftColumnTitle.isHidden)
                      ? (_openBlock(), _createBlock(EditableElement, {
                          key: 0,
                          blockId: _ctx.block.id,
                          fieldName: "leftColumnTitle"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(BlockTitle, {
                              text: dataValues.value.leftColumnTitle.data.text,
                              textColor: styleValues.value.cardText
                            }, null, 8, ["text", "textColor"])
                          ]),
                          _: 1
                        }, 8, ["blockId"]))
                      : _createCommentVNode("", true),
                    (!dataValues.value.leftColumnDescription.isHidden)
                      ? (_openBlock(), _createBlock(EditableElement, {
                          key: 1,
                          blockId: _ctx.block.id,
                          fieldName: "leftColumnDescription"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(BlockDescription, {
                              text: dataValues.value.leftColumnDescription.data.text,
                              textColor: styleValues.value.cardText
                            }, null, 8, ["text", "textColor"])
                          ]),
                          _: 1
                        }, 8, ["blockId"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    (!dataValues.value.leftColumnImage.isHidden)
                      ? (_openBlock(), _createBlock(EditableElement, {
                          key: 0,
                          blockId: _ctx.block.id,
                          fieldName: "leftColumnImage"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(Media, {
                                data: dataValues.value.leftColumnImage.data,
                                "image-width": 327,
                                "image-height": 668,
                                "video-width": 327,
                                "video-height": 668
                              }, null, 8, ["data"])
                            ])
                          ]),
                          _: 1
                        }, 8, ["blockId"]))
                      : _createCommentVNode("", true)
                  ])
                ], 4)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", {
                  class: "rounded-lg border p-8 lg:h-1/2 overflow-hidden flex flex-col gap-4",
                  style: _normalizeStyle({
                                borderColor: styleValues.value.border,
                                backgroundColor: styleValues.value.cardBackground,
                            })
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    (!dataValues.value.topCenterColumnTitle.isHidden)
                      ? (_openBlock(), _createBlock(EditableElement, {
                          key: 0,
                          blockId: _ctx.block.id,
                          fieldName: "topCenterColumnTitle"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(BlockTitle, {
                              text: dataValues.value.topCenterColumnTitle.data.text,
                              textColor: styleValues.value.cardText
                            }, null, 8, ["text", "textColor"])
                          ]),
                          _: 1
                        }, 8, ["blockId"]))
                      : _createCommentVNode("", true),
                    (!dataValues.value.topCenterColumnDescription.isHidden)
                      ? (_openBlock(), _createBlock(EditableElement, {
                          key: 1,
                          blockId: _ctx.block.id,
                          fieldName: "topCenterColumnDescription"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(BlockDescription, {
                              text: dataValues.value.topCenterColumnDescription.data.text,
                              textColor: styleValues.value.cardText
                            }, null, 8, ["text", "textColor"])
                          ]),
                          _: 1
                        }, 8, ["blockId"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    (!dataValues.value.topCenterColumnImage.isHidden)
                      ? (_openBlock(), _createBlock(EditableElement, {
                          key: 0,
                          blockId: _ctx.block.id,
                          fieldName: "topCenterColumnImage"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_11, [
                              _createVNode(Media, {
                                data: dataValues.value.topCenterColumnImage.data,
                                "image-width": 327,
                                "image-height": 218,
                                "video-width": 327,
                                "video-height": 218
                              }, null, 8, ["data"])
                            ])
                          ]),
                          _: 1
                        }, 8, ["blockId"]))
                      : _createCommentVNode("", true)
                  ])
                ], 4),
                _createElementVNode("div", {
                  class: "rounded-lg border p-8 lg:h-1/2 overflow-hidden flex flex-col gap-4",
                  style: _normalizeStyle({
                                borderColor: styleValues.value.border,
                                backgroundColor: styleValues.value.cardBackground,
                            })
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    (!dataValues.value.bottomCenterColumnTitle.isHidden)
                      ? (_openBlock(), _createBlock(EditableElement, {
                          key: 0,
                          blockId: _ctx.block.id,
                          fieldName: "bottomCenterColumnTitle"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(BlockTitle, {
                              text: dataValues.value.bottomCenterColumnTitle.data.text,
                              textColor: styleValues.value.cardText
                            }, null, 8, ["text", "textColor"])
                          ]),
                          _: 1
                        }, 8, ["blockId"]))
                      : _createCommentVNode("", true),
                    (!dataValues.value.bottomCenterColumnDescription.isHidden)
                      ? (_openBlock(), _createBlock(EditableElement, {
                          key: 1,
                          blockId: _ctx.block.id,
                          fieldName: "bottomCenterColumnDescription"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(BlockDescription, {
                              text: dataValues.value.bottomCenterColumnDescription.data.text,
                              textColor: styleValues.value.cardText
                            }, null, 8, ["text", "textColor"])
                          ]),
                          _: 1
                        }, 8, ["blockId"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    (!dataValues.value.bottomCenterColumnImage.isHidden)
                      ? (_openBlock(), _createBlock(EditableElement, {
                          key: 0,
                          blockId: _ctx.block.id,
                          fieldName: "bottomCenterColumnImage"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(Media, {
                                data: dataValues.value.bottomCenterColumnImage.data,
                                "image-width": 327,
                                "image-height": 218,
                                "video-width": 327,
                                "video-height": 218
                              }, null, 8, ["data"])
                            ])
                          ]),
                          _: 1
                        }, 8, ["blockId"]))
                      : _createCommentVNode("", true)
                  ])
                ], 4)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", {
                  class: "rounded-lg border p-8 h-full overflow-auto flex flex-col gap-4",
                  style: _normalizeStyle({
                                borderColor: styleValues.value.border,
                                backgroundColor: styleValues.value.cardBackground,
                            })
                }, [
                  _createElementVNode("div", _hoisted_16, [
                    (!dataValues.value.rightColumnTitle.isHidden)
                      ? (_openBlock(), _createBlock(EditableElement, {
                          key: 0,
                          blockId: _ctx.block.id,
                          fieldName: "rightColumnTitle"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(BlockTitle, {
                              text: dataValues.value.rightColumnTitle.data.text,
                              textColor: styleValues.value.cardText
                            }, null, 8, ["text", "textColor"])
                          ]),
                          _: 1
                        }, 8, ["blockId"]))
                      : _createCommentVNode("", true),
                    (!dataValues.value.rightColumnDescription.isHidden)
                      ? (_openBlock(), _createBlock(EditableElement, {
                          key: 1,
                          blockId: _ctx.block.id,
                          fieldName: "rightColumnDescription"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(BlockDescription, {
                              text: dataValues.value.rightColumnDescription.data.text,
                              textColor: styleValues.value.cardText
                            }, null, 8, ["text", "textColor"])
                          ]),
                          _: 1
                        }, 8, ["blockId"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    (!dataValues.value.rightColumnImage.isHidden)
                      ? (_openBlock(), _createBlock(EditableElement, {
                          key: 0,
                          blockId: _ctx.block.id,
                          fieldName: "rightColumnImage"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_18, [
                              _createVNode(Media, {
                                data: dataValues.value.rightColumnImage.data,
                                "image-width": 327,
                                "image-height": 668,
                                "video-width": 327,
                                "video-height": 668
                              }, null, 8, ["data"])
                            ])
                          ]),
                          _: 1
                        }, 8, ["blockId"]))
                      : _createCommentVNode("", true)
                  ])
                ], 4)
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["id", "backgroundColor", "scrollAnimationType"]))
}
}

})